import {NgModule, inject} from '@angular/core';
import {provideApollo} from 'apollo-angular';
import {InMemoryCache} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import { environment } from 'src/environments/environment';

const uri =`${environment.apiGlobalUrl}/Prod/graphql/`; // <-- add the URL of the GraphQL server here

@NgModule({
  providers: [
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      return {
        link: httpLink.create({uri}),
        cache: new InMemoryCache(),
      };
    }),
  ],
})
export class GraphQLModule {}
